var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppAdvCareCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "375px",
    height: "11px",
    viewBox: "0 0 375 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "06_Pedidos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-A-06-01-03-Copy-4",
    transform: "translate(0.000000, -54.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.362492 C69.6666667,3.45416402 131.833333,0 186.5,0 C239.5,0 302.333333,3.4797555 375,10.4392665 L375,10.5856403 L0,10.5856403 L0,10.362492 Z",
    id: "Rectangle",
    transform: "translate(187.500000, 5.292820) scale(-1, 1) translate(-187.500000, -5.292820) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppAdvCareCurve);
export default __webpack_public_path__ + "static/media/App_AdvCare_curve.6dad7808be65a6bae785678d9af19052.svg";
export { ForwardRef as ReactComponent };